import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";

const SyncInternationalPriceRoundingOutput_ = z.object({
  catalogsUpdated: z.number(),
  catalogsReverted: z.number(),
  variantsUpdated: z.number(),
  variantsReverted: z.number(),
  errors: z.array(z.string()),
});

export const SyncInternationalPriceRoundingOutput: z.ZodType<SyncInternationalPriceRoundingOutput> =
  SyncInternationalPriceRoundingOutput_;
export interface SyncInternationalPriceRoundingOutput
  extends z.infer<typeof SyncInternationalPriceRoundingOutput_> {}

export const syncInternationalPriceRounding = {
  name: "syncInternationalPriceRounding" as const,
  input: z.object({
    teamId: zExt.objectId(),
    catalogIdsToRevert: z.array(z.string()).optional(),
  }),
  output: SyncInternationalPriceRoundingOutput,
};
